import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import LandingPagesLayout from '../../../components/ng/en/get-a-loan/landingPagesLayout';
import { useHeroImage } from '../../../components/ng/en/get-a-loan/hooks/useHeroImage';
import { WhyLidya } from '../../../components/ng/en/get-a-loan/why.lidya.points';
import GrowYourBusiness from '../../../components/ng/en/get-a-loan/grow.your.business';
import Investors from '../../../components/ng/en/get-a-loan/who.our.investors';
import Testimonials from '../../../components/ng/en/get-a-loan/testimonials';
import Featured from '../../../../components/content/home/home.featured.in';
import KeyIndicators from '../../../components/ng/en/get-a-loan/key.indicators';
import HelpingBanner from '../../../components/ng/en/get-a-loan/helping.banner';
import PerfectBusiness from '../../../components/ng/en/get-a-loan/perfect.business';

/* This Should Exists in every Landing Page index file, it makes sure the correct language is used */
const LANGUAGE = 'en';
const COUNTRY = 'ng';
/* This Should Exists in every Landing Page index file, it makes sure the correct language is used */

const Home = ({ location }) => {
  const {
    imageFileName, imagePosition, imageTitle, imageAlt,
  } = useHeroImage();
  return (
    <LandingPagesLayout
      pageTitle="get.loan.label.main"
      description="perfect.business.finance.description"
      title="get.loan.label.main"
      keywords="seo.keywords.home"
      imageFileName={imageFileName}
      imageTitle={imageTitle}
      imageAlt={imageAlt}
      location={location}
      country={COUNTRY}
      language={LANGUAGE}
      imagePosition={imagePosition}
      noLanguageChoice
    >
      <WhyLidya />
      <PerfectBusiness />
      <KeyIndicators />
      <Testimonials />
      <GrowYourBusiness />
      <Featured title="featured.title" />
      <Investors />
      <HelpingBanner />
    </LandingPagesLayout>
  );
};

Home.propTypes = {
  location: PropTypes.shape({}),
};

Home.defaultProps = {
  location: {
    pathname: '',
    search: '',
  },
};

export default Home;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
